var _mask;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContacts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_251_63695",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.60156 8.99998C5.60156 12.5346 8.46692 15.4 12.0016 15.4C15.5362 15.4 18.4016 12.5346 18.4016 8.99998C18.4016 5.46534 15.5362 2.59998 12.0016 2.59998C8.46692 2.59998 5.60156 5.46534 5.60156 8.99998ZM5.20078 16.3999C3.8753 16.3999 2.80078 17.4745 2.80078 18.7999C2.80078 20.1254 3.87529 21.1999 5.20078 21.1999H18.8008C20.1263 21.1999 21.2008 20.1254 21.2008 18.7999C21.2008 17.4745 20.1263 16.3999 18.8008 16.3999H5.20078Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M12.0016 14.4C9.01921 14.4 6.60156 11.9823 6.60156 8.99998H4.60156C4.60156 13.0869 7.91464 16.4 12.0016 16.4V14.4ZM17.4016 8.99998C17.4016 11.9823 14.9839 14.4 12.0016 14.4V16.4C16.0885 16.4 19.4016 13.0869 19.4016 8.99998H17.4016ZM12.0016 3.59998C14.9839 3.59998 17.4016 6.01762 17.4016 8.99998H19.4016C19.4016 4.91305 16.0885 1.59998 12.0016 1.59998V3.59998ZM6.60156 8.99998C6.60156 6.01762 9.01921 3.59998 12.0016 3.59998V1.59998C7.91464 1.59998 4.60156 4.91305 4.60156 8.99998H6.60156ZM3.80078 18.7999C3.80078 18.0267 4.42758 17.3999 5.20078 17.3999V15.3999C3.32301 15.3999 1.80078 16.9222 1.80078 18.7999H3.80078ZM5.20078 20.1999C4.42758 20.1999 3.80078 19.5731 3.80078 18.7999H1.80078C1.80078 20.6777 3.32301 22.1999 5.20078 22.1999V20.1999ZM18.8008 20.1999H5.20078V22.1999H18.8008V20.1999ZM20.2008 18.7999C20.2008 19.5731 19.574 20.1999 18.8008 20.1999V22.1999C20.6785 22.1999 22.2008 20.6777 22.2008 18.7999H20.2008ZM18.8008 17.3999C19.574 17.3999 20.2008 18.0267 20.2008 18.7999H22.2008C22.2008 16.9222 20.6786 15.3999 18.8008 15.3999V17.3999ZM5.20078 17.3999H18.8008V15.3999H5.20078V17.3999Z",
    fill: "#666666",
    style: {
      fill: "#666666",
      fill: "color(display-p3 0.4000 0.4000 0.4000)",
      fillOpacity: 1
    },
    mask: "url(#path-1-inside-1_251_63695)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContacts);
export default __webpack_public_path__ + "static/media/contacts.bdee8563bd42943e0a46e1cac89ef775.svg";
export { ForwardRef as ReactComponent };